import { render, staticRenderFns } from "./ClientsLandingPage.vue?vue&type=template&id=06945289&scoped=true"
import script from "./ClientsLandingPage.vue?vue&type=script&lang=js"
export * from "./ClientsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ClientsLandingPage.vue?vue&type=style&index=0&id=06945289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06945289",
  null
  
)

export default component.exports